import React from 'react';
import BaseEntityList from './BaseEntityList';
import { Product } from 'data/terra/Product';
import { selectProduct } from 'containers/store/productSelector/actions/SelectProduct';
import { completeGuideAction } from 'containers/Guide/store/guide/actions';
import { isGuideWaitingForAction } from 'data/ui/guide/Guide';
import { EntityDesc } from './BaseAddEntityPopup/BaseAddEntityPopup';
import Terra from 'services/apis/terra/Terra';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import { useHistory } from 'react-router-dom';
import { fetchProducts } from 'containers/store/productSelector/actions/FetchProducts';

function ListProduct() {
  const history = useHistory();
  const dispatch = useDispatch();
  const onGoingGuide = useSelector(
    (state: RootState) => state.guide.onGoingGuide
  );
  const products = useSelector(
    (state: RootState) => state.productSelector.products
  );

  return (
    <BaseEntityList<Product>
      entityName="Product"
      entities={products}
      itemsPerRow={4}
      onEntitySelected={(product: Product) => {
        dispatch(selectProduct(product.id));
        dispatch(completeGuideAction('selectProduct'));

        if (!isGuideWaitingForAction('selectProduct', onGoingGuide)) {
          // if in guide mode, guide manager will do redirect
          history.push(`/products/${product.code}/users`);
        }
      }}
      onSaveEntity={async (desc: EntityDesc) => {
        return Terra.product.addProduct(desc);
      }}
      onSaveEntityResult={result => {
        if (result.isSuccess()) {
          dispatch(fetchProducts());
        }
      }}
    />
  );
}

export default ListProduct;
